import { render, staticRenderFns } from "./CalendarDay.vue?vue&type=template&id=563a1c8c&"
import script from "./CalendarDay.vue?vue&type=script&lang=js&"
export * from "./CalendarDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports